import React from "react";
import ActionLog from "modules/actionLog";

const ActionLogPage = () => {
  return <ActionLog />;
};

export default ActionLogPage;
